import { render, staticRenderFns } from "./ListAssetTypes.vue?vue&type=template&id=656728aa"
import script from "./ListAssetTypes.vue?vue&type=script&lang=js"
export * from "./ListAssetTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports